import axios from "axios";
import { baseUrl, config, requestID } from "../../common/utils";

// Get available rooms for a specific date
export const getAvailableRoomsForToday = async (date) => {
  try {
    const response = await axios.post('/hotel/available-rooms', {
      params: { date }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get today's bookings
export const getBookingsForToday = async (date) => {
      const data = {
        requestID: requestID(),
        ...date
    };
  try {
    const response = await axios.post(baseUrl() + 'orderhistorys/fetchAvailableRooms', data,
            config );
    console.log({response});
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
export const addCryptoCurrencyAPI = async (payload) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "crypto_currencys/add",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCryptoCurrenciesAPI = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "crypto_currencys/getAll",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const deleteCryptoCurrencyAPI = async (symbol) => {
    const data = {
        requestID: requestID(),
        symbol
    };
    try {
        const response = await axios.post(
            baseUrl() + "crypto_currencys/delete",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const updateCryptoCurrencyAPI = async (payload) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "crypto_currencys/update",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const addGiftcardTypeAPI = async (payload) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "giftcard_currencys/add",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getGiftcardTypesAPI = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "giftcard_currencys/getAll",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const deleteGiftcardTypeAPI = async (symbol) => {
    const data = {
        requestID: requestID(),
        symbol
    };
    try {
        const response = await axios.post(
            baseUrl() + "giftcard_currencys/delete",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const updateGiftcardTypeAPI = async (payload) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "giftcard_currencys/update",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const getProcessorOrders = async (payload) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getProcessorOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getOrders = async (payload) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const createOrder = async (payload) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/createOrder",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const createBarOrder = async (payload) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/createBarOrder",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
 
export const createStewardOrder = async (payload) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/createStewardOrder",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
 


export const updateOrder = async (payload) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/updateOrder",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}



export const orderReport = async (payload) => {
    const data = {
        requestID: requestID(),...payload
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/orderReport",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getAllOrders = async (payload) => {
    const data = {
        requestID: requestID(),...payload
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getAllOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getAllOrders_club = async (payload) => {
    const data = {
        requestID: requestID(),...payload
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getAllOrders_club",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getAllMyOrders = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getAllMyOrderWithItems",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const orderHistory = async (payload) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getMyOrderHistory",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}





export const orderSales = async (payload) => {
    const data = {
        requestID: requestID(),...payload
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/orderSales",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const approvedOrders = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/approvedOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const processPayment = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/processPayment",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const sendOTP = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/sendOTP",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}



export const getMyOrders = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getMyOrderWithItems",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

// Placeholder for bank account verification 
//  await new Promise(resolve => setTimeout(resolve, 1500));


 
export const getCustomerBanks = async (customerId)=>{

try {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("member_id", customerId); // ✅ fixed
 
 
    const response = await axios.post(
      baseUrl() + "orderhistorys/getCustomerBanks",
      formData,
      config
    );

    console.log("getCustomerBanks Response :", response.data);

    return response; // ✅ return only needed data
  } catch (error: any) {
    console.error("Error getCustomerBanks bank account:", error);

    // ✅ return structured error
    return error.response?.data || { message: error.message };
  }

}

export const getExternalProcessorsAPI = async ()=>{

    try {
        const formData = new FormData();
        formData.append("requestID", requestID());
    

        const response = await axios.post(
            baseUrl() + "orderhistorys/getAllExternalProcessors",
            formData,
            config
        );

        console.log("getExternalProcessorsAPI Response :", response.data);

        return response.data;
    } catch (error: any) {
        console.error("Error fetching external processors:", error);
        return error.response?.data || { message: error.message };
    }

}


export const addExternalProcessorAPI = async (dataApi)=>{

    try {
      
   const data = {
        requestID: requestID(),...dataApi
        // data: payload
    };
        const response = await axios.post(
            baseUrl() + "orderhistorys/addExternalProcessor",
            data,
            config
        );

        console.log("addExternalProcessorAP Response :", response.data);

        return response.data;
    } catch (error: any) {
        console.error("Error fetching addExternalProcessorAP processors:", error);
        return error.response?.data || { message: error.message };
    }

}


export const updateExternalProcessorAPI = async (dataApi)=>{

    try {
      
   const data = {
        requestID: requestID(),...dataApi
        // data: payload
    };
        const response = await axios.post(
            baseUrl() + "orderhistorys/updateExternalProcessor",
            data,
            config
        );

        console.log("addExternalProcessorAP Response :", response.data);

        return response.data;
    } catch (error: any) {
        console.error("Error fetching addExternalProcessorAP processors:", error);
        return error.response?.data || { message: error.message };
    }

}


export const deleteExternalProcessorAPI = async(dataApi)=>{

   try {
      
   const data = {
        requestID: requestID(),
        processor_id: dataApi
        // data: payload
    };
        const response = await axios.post(
            baseUrl() + "orderhistorys/deleteExternalProcessor",
            data,
            config
        );

        console.log("deleteExternalProcessorAPI Response :", response.data);

        return response.data;
    } catch (error: any) {
        console.error("Error fetching deleteExternalProcessorAPI processors:", error);
        return error.response?.data || { message: error.message };
    }

}


export const verifyBankAccount = async (accountNumber: string, bankCode: string) => {
  try {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("accountNumber", accountNumber); // ✅ fixed
    formData.append("bankCode", bankCode);

    console.log("Payload:", [...formData]); // log key-value pairs

    const response = await axios.post(
      baseUrl() + "warehouses/getAccountName",
      formData,
      config
    );

    console.log("Response:", response.data);

    return response.data.data; // ✅ return only needed data
  } catch (error: any) {
    console.error("Error verifying bank account:", error);

    // ✅ return structured error
    return error.response?.data || { message: error.message };
  }
};


export const createCustomerOrder_Crypto = async (payload) => {
    console.log({ payload })
    const data = {
        requestID: requestID(),...payload,
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/createCustomerOrder_Crypto",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const checkOutCustomers = async (order_id) => {
    // console.log({ payload })
    const data = {
        requestID: requestID(),
        order_id: order_id
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/checkOutCustomers",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const createCustomerOrder_giftCard = async (payload) => {
    console.log({ payload })
    const data = {
        requestID: requestID(),...payload,
        // data: payload cardCode giftcardType
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/createCustomerOrder_giftCard",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}






export const fetchBookedDates = async (product_id, month) => {
    const data = {
        requestID: requestID(),product_id, month
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/fetchBookedDates",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const createHotelBooking = async (payload) => {
    const data = {
        requestID: requestID(),...payload
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/createHotelBooking",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        // // console.log({ error })
        //     console.error("Error fetching deleteExternalProcessorAPI processors:", error);
        return error
        // return error
    }

}


export const saveOrderSummaryApi = async (payload) => {
    const data = {
        requestID: requestID(),...payload

    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/saveOrderSummaryApi",
            data,
            config
        );
        console.log({ 'xsaveOrderSummaryApi' : response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const createCustomerOrder_online = async (payload) => {
    const data = {
        requestID: requestID(),...payload
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/createCustomerOrder_online",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const createCustomerOrder = async (payload) => {
    const data = {
        requestID: requestID(),...payload
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/createCustomerOrder",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}






export const getContraData = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getContraData",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}



export const getCashierOrders_reciept_date = async (start,end) => {
    const data = {
        requestID: requestID(),
        start: start,
        end: end
    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getCashiersOrders_reciept",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getCashierOrders_reciept = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getCashiersOrders_reciept",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getCashierOrders = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "reports/getCashiersOrders1",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const getBranchOrders = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getBranchOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}





